import { render, staticRenderFns } from "./DefaultPartiesFilters.vue?vue&type=template&id=4f796a6c&"
import script from "./DefaultPartiesFilters.vue?vue&type=script&lang=js&"
export * from "./DefaultPartiesFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports